// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YiRd","name":"Header_name__37brs","birthday":"Header_birthday__3E9pO","skeleton":"Header_skeleton__ITIdB"};